import PlusIcon from "assets/icon/PlusIcon";
import XIcon from "assets/icon/XIcon";
import SaveButton from "components/Button/SaveButton";
import { MainBodyCard, PagesTitle } from "components/Cards";
import { useModal } from "utils/context/ModalContext";
import { useEffect, useRef, useState } from "react";
import { BankBalanceService } from "services/BankBalanceService/BankBalanceService";
import { addSpaceEvery4, money } from "utils/helpers";
import { CustomerCardService } from "services/CustomerCardService/CustomerCardService";
import Select from "react-select";

export default function FrequentCustomer() {
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerCardList } = CustomerCardService()

    const [currentSelectedFrequentCustomer, setCurrentSelectedFrequentCustomer] = useState(JSON.parse(localStorage.getItem('FrequentCustomer')) || [])
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [selectedCustomerCardId, setSelectedCustomerCardId] = useState([])
    const [selectedCustomerCard, setSelectedCustomerCard] = useState([])

    const getCustomerCard = async (name) => {
        const res = await fetchCustomerCardList(
            name,
            '',
            0,
            0,
            '1',
            50,
            0
        )
        if (!res) return

        const data = res.data.listData
        const options = data.map((item) => 
            ({label: item.customerName.toUpperCase() + ' - ' + addSpaceEvery4(item.cardNumber) + ' (' + item.bankCode.toUpperCase().trim() + ')', value: String(item.customerCardId), ...item}))

        setCustomerCardOptions(options)
    }

    const customerCardInputChange = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            try {
                showLoading()

                getCustomerCard(e)
            } finally {
                hideLoading()
            }
        }, 500)
    }

    useEffect(() => {
        // const onLoad = async () => {
        //     showLoading()

        //     try {
        //         await getBankBalance()
        //     }
        //     finally {
        //         hideLoading()
        //     }
        // }

        // onLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesTitle title='Frequent Customer' />

            <div>
                <div className="p-2 shadow-md border rounded-xl bg-white">
                    <span className="font-semibold text-xl">Selected Customer Card</span>

                    <div className=" gap-2">
                        {currentSelectedFrequentCustomer.map((data) => {
                            console.log(data)

                            return (
                                <div key={data.value}>
                                    <span>{data.customerName}</span>
                                </div>
                            )
                        })}
                    </div>

                    <div className="mt-4">
                        <SaveButton 
                            onClick={() => {
                                localStorage.setItem('FrequentCustomer', JSON.stringify(currentSelectedFrequentCustomer))
                                showSuccess()
                            }} 
                            visible={true} 
                        />
                    </div>
                </div>
            </div>
            
            <div className="mt-4">
                <span className="font-semibold text-xl">Available Bank Account</span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 gap-2">
                <Select 
                    options={customerCardOptions} 
                    value={customerCardOptions.find(x => x.value === selectedCustomerCardId)} 
                    onChange={(e) => setSelectedCustomerCard(e)} 
                    onInputChange={customerCardInputChange}
                />

                <button
                    className={`button
                        
                        rounded-full p-1`}
                    onClick={() => {
                        // const selected = customerCardOptions.find(
                        //     (x) => x.value === selectedCustomerCardId
                        // )

                        if (!selectedCustomerCard) return

                        setCurrentSelectedFrequentCustomer((prev) => [
                            ...prev,
                            selectedCustomerCard
                        ])
                    }}
                >
                    <span>Add to list</span>
                </button>  
            </div>
        </MainBodyCard>
    )
}